import styled from 'styled-components'

export const Wrapper = styled.div`
opacity: ${({ opacity }) => opacity};
position: relative;
transition: opacity 0.5s ease-in-out;
`;